// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for Error structure.
 * @see #/components/schemas/ErrorDetails - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ErrorDetails {
    /**
     * domain.error_case
     *
     */
    code: string;
    /**
     * Human-readable title of the error case.
     *
     */
    title: string;
    /**
     * any additional information
     *
     */
    details: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ErrorDetails
 */
export namespace ErrorDetails {
    /**
     * ErrorDetails Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * domain.error_case
         * @type string (`dataFormat` is missing)
         */
        code: string;
        /**
         * Human-readable title of the error case.
         * @type string (`dataFormat` is missing)
         */
        title: string;
        /**
         * any additional information
         * @type string (`dataFormat` is missing)
         */
        details: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ErrorDetails DTO
     * Transforms ErrorDetails model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ErrorDetails model */
        static toModel(obj: ErrorDetails): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ErrorDetails model */
        static toApi(obj: Model): ErrorDetails {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ErrorDetails;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
